import * as $ from "jquery"
import * as Cookies from "js-cookie";
import { DialogContext } from "bootstrap-dialog";
import { App } from "../../_app";
import { Resources } from "../resources";
import { Dialogs } from "../dialogs/dialogs";
import { LicensePlate } from "./licenseplate";
import { Validation } from "./validation";
import { ShowHide } from "./show-hide";
import { Alerts } from "./alerts";
import { Util } from "./util";

//App.Common.Functions
export class Functions {
    static readonly LicensePlate = LicensePlate;
    static readonly Validation = Validation;
    static readonly ShowHide = ShowHide;
    static readonly Util = Util;
    static readonly Alerts = Alerts;
    static pageIsScrolling = false;

    static init(): void {
        Validation.init();
        Functions.initLoadHistory();
        Functions.displayNonSupportedBrowserMessage();
        Functions.displayAdBlockerBrowserMessage();
        Functions.displayChatToSupportedBrowser();
        Functions.addGlobalEventhandlers();
    }

    static getAntiForgeryToken() {
        const element = <HTMLInputElement>document.querySelector("[name=__RequestVerificationToken]");
        return element.value;
    }

    static addGlobalEventhandlers() {

        document.querySelectorAll("button[data-remove-selection-id]").forEach(
            button => button.addEventListener("click", () => Functions.removeSelection(button.getAttribute("data-remove-selection-id"))));

        $("input, select, textarea").on("focusout",
            function () {
                App.inputChanged = true;
            });

        $("input[type=checkbox][readonly]").each(function () {
            $(this).attr("disabled", "true");
        });


        $(window).bind("resizeEnd", function () {
            /* Collapsing Header */
            if ($(".epi-edit").length === 0) { // nicht für CMS
                const minContainerHeight = window.innerHeight - $("header").height();
                $(".dv-background-placeholder").css("min-height", minContainerHeight);
            }

            if (window.innerWidth >= 1024) {
                $("#topNav").slideDown();

            } else if ($(".navbar-toggle").hasClass("collapsed")) {
                $("#topNav").slideUp();

            }
        });

        /* Warning to loose data on views with filled out input fields */
        $("#lang-list a").click(function (e) {
            e.preventDefault();
            const langChanged = Dialogs.warningLooseOfData(<HTMLAnchorElement>this, false);
            if (langChanged === true) {
                App.saveLangInSession(<HTMLAnchorElement>this);
            }
        });

        // Toggle Menu on hover
        $("#main-nav-collapse .dropdown, #topNav .dropdown").mouseenter(function () {
            if (window.innerWidth >= 1024) {
                $(this).addClass("open");
            }
        }).mouseleave(function () {
            if (window.innerWidth >= 1024) {
                $(this).removeClass("open");
            }
        }).click(function () {
            if (window.innerWidth >= 1024) {
                $(this).removeClass("open");
            }
        });

        /* Show forms only if JS is activated */
        $("main").find(".nojs").each(function () {
            $(this).removeClass("nojs");
        })

        const options = document.querySelectorAll(".selectpicker > option");
        Array.prototype.forEach.call(options, function (el: Element) {
            const text = el.textContent;
            el.textContent = text.trim();
        });

        $(".dropdown-toggle").on("keydown", function (e) {
            if (e.code === "Space") {
                $(e.target).trigger("click");
            }
        });

        $(document).on("shown.bs.modal", ".modal", function () {
            $(this).find(".btn:last").focus();
        });

        $(document).on("hidden.bs.modal", ".modal", function () {
            const modals = $(".modal").is(":visible");
            if (modals) {
                $(".modal:visible").focus();
            }
        });

    }

    static setFieldRequired(id: string, required: boolean): boolean {
        if (required) {
            document.getElementById(id).setAttribute("required", "true");
        } else {
            document.getElementById(id).removeAttribute("required");
        }
        return required;
    }

    static hasValue(elem: HTMLElement) {
        return (<HTMLInputElement>elem)?.value != null;
    }

    static changeContrast(): void {
        $("body").toggleClass("contrast");
        Cookies.set("contrast", String($("body").hasClass("contrast")), { expires: 365, secure: true, sameSite: "lax" });
    }

    static displayAdBlockerBrowserMessage() {
        const element = document.getElementById("ad-blocker-warning");
        if (typeof element !== "undefined") {
            setTimeout(() => {
                if (!Object.prototype.hasOwnProperty.call(window, "Matomo")) {
                    App.Common.Logging.logInfo("Es wurde die Adblocker Warnung angezeigt.");
                    Functions.ShowHide.show(element);
                }
            }, 4000);
        }
    }
    static displayNonSupportedBrowserMessage() {
        const browserCheckRegex: string = document.getElementById("body").getAttribute("data-not-supported-browser-regex");
        const browserNotSupportedMessage: string = document.getElementById("body").getAttribute("data-not-supported-browser-message");
        if (!(browserCheckRegex?.length > 0) || browserNotSupportedMessage == null)
            return;

        const browserCheckRegexArray = browserCheckRegex.split("','");
        if (!Array.isArray(browserCheckRegexArray) || browserCheckRegexArray.length == 0)
            return;
        const userAgent = navigator.userAgent;
        let showNotSupportedBrowserMessage = false;
        browserCheckRegexArray.forEach((item) => {
            if (!showNotSupportedBrowserMessage) {
                const regexp = new RegExp(item, "g");
                showNotSupportedBrowserMessage = userAgent.match(regexp) != null;
            }
        });
        if (showNotSupportedBrowserMessage) {
            const container = document.createElement("div");
            container.classList.add("container");
            container.classList.add("d-print-none");

            const row = document.createElement("div");
            row.className = "row";
            const col = document.createElement("div");
            col.classList.add("col-12");
            col.classList.add("alert");
            col.classList.add("alert-warning");
            col.innerHTML = browserNotSupportedMessage;
            row.appendChild(col);
            container.appendChild(row);
            $("main").prepend(container);
        }
    }

    static displayChatToSupportedBrowser() {

        document.getElementById("communication-widget-contact-toggle")?.addEventListener("click", () => {
            App.Common.Logging.logInfo("communication.widget.clicked");
            ShowHide.show("contact-widget");
            ShowHide.hide("communication-widget-contact-toggle");
        });
        document.getElementById("contact-widget-header")?.addEventListener("click", () => {
            ShowHide.hide("contact-widget");
            ShowHide.show("communication-widget-contact-toggle");
        });

        const browserCheckRegexString: string = document.getElementById("body").getAttribute("data-not-supported-chat-browser-regex");

        if (browserCheckRegexString != null && browserCheckRegexString.length > 0) {
            const browserCheckRegex = browserCheckRegexString.split(",");
            window.addEventListener("DOMContentLoaded", () => {
                const userAgent = navigator.userAgent;
                let showChatButton = false;
                browserCheckRegex.forEach((item) => {
                    if (!showChatButton && item.length > 0) {
                        const regexp = new RegExp(item, "g");
                        showChatButton = userAgent.match(regexp) != null;
                    }
                });
                if (!showChatButton) {
                    document.getElementById("communication-widget-chat")?.classList.add("d-md-flex");
                }
            });
        }
    }

    static displaySubmitButtonsAfterCaptchaReady() {
        $(".hidden-till-captcha-validated").removeClass("hidden-till-captcha-validated");
    }

    static dockCommunicationWidgetToFooter() {
        $(window).scroll(function () {
            Functions.makeCommunicationWidgetSticky();
        });

        $(window).on("show.bs.collapse", function () {
            Functions.makeCommunicationWidgetSticky();
        });

        $(window).resize(function () {
            Functions.makeCommunicationWidgetSticky();
        });
        Functions.makeCommunicationWidgetSticky();
    }

    static makeCommunicationWidgetSticky() {
        if (Functions.needPageScrollingToFooter()) {
            const footerHeight = $("footer").position().top - $("#communication-widget").innerHeight();
            $("#communication-widget").addClass("sticky");
            $("#communication-widget").css("top", footerHeight + "px");
        } else {
            $("#communication-widget").removeClass("sticky");
            $("#communication-widget").css("top", "");
        }
    }

    static needPageScrollingToFooter() {
        return ($(window).height() + $(window).scrollTop()) > $("footer")?.position()?.top;
    }

    static isModalDialogOpen() {
        return document.querySelector(".modal.show") != null;
    }
    static scrollToError() {
        if (Functions.isModalDialogOpen())
            return;
        let position = 0;
        if ($("form .input-validation-error:visible:first").length > 0) {
            if (document.getElementById("PurchaseAssistantVehicleDataForm") == null) {
                const firstError = $("form .input-validation-error:visible:first");
                position = $(firstError).offset().top;
                if ($(firstError).parent().hasClass("datepicker"))
                    position -= 265;
                else if ($(firstError).parent().hasClass("mtcaptcha"))
                    position -= 265;
                else if ((<HTMLElement>$(firstError).parent()[0].lastChild).id === "IsAgbConfirmed-error") {
                    position = $("#IsAgbConfirmed").offset().top;
                }
                else if ((<HTMLElement>$(firstError).parent()[0].lastChild).id === "checkagb-error") {
                    position = $("#checkagb").offset().top;
                } else if ($(firstError)[0].id === "evidence-widget-licenseplate") {
                    position = 0;
                }
            }
        }
        if (position > 0) {
            Functions.scrollToPosition(position - 150);
        }
    }

    static scrollToPosition(position: number, delay = 1000) {
        if (position >= 0 && Functions.pageIsScrolling === false) {
            Functions.pageIsScrolling = true;
            $("html, body").animate({
                scrollTop: position
            }, delay).promise().then(function () {
                Functions.pageIsScrolling = false;
            });
        }
    }

    static isElementInViewport(el: HTMLElement) {
        const rect = el?.getBoundingClientRect();

        if (rect == null) {
            return false;
        }

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }

    static fixAccessibility() {
        const originalhide = $.fn.hide;
        $.fn.hide = function () {
            // eslint-disable-next-line
            const r = originalhide.apply(this, arguments);
            r.attr("aria-hidden", "true");
            Functions.makeCommunicationWidgetSticky();
            return r;
        };

        const originalshow = $.fn.show;
        $.fn.show = function () {
            // eslint-disable-next-line
            const r = originalshow.apply(this, arguments);
            r.attr("aria-hidden", "false");
            Functions.makeCommunicationWidgetSticky();
            return r;
        };

        const originalslidedown = $.fn.slideDown;
        $.fn.slideDown = function () {
            // eslint-disable-next-line
            const r = originalslidedown.apply(this, arguments);
            r.attr("aria-hidden", "false");
            Functions.makeCommunicationWidgetSticky();
            return r;
        };

        const originalslideup = $.fn.slideUp;
        $.fn.slideUp = function () {
            // eslint-disable-next-line
            const r = originalslideup.apply(this, arguments);
            r.attr("aria-hidden", "true");
            Functions.makeCommunicationWidgetSticky();
            return r;
        };
    }

    static getResponsiveBreakpoint() {
        const envs = { xs: "d-none", sm: "d-sm-none", md: "d-md-none", lg: "d-lg-none", xl: "d-xl-none" };
        let env: envsKeyType = "" as envsKeyType;

        const $el = $("<div>");
        $el.appendTo($("body"));

        type envsKeyType = keyof typeof envs;

        for (let i = Object.keys(envs).length - 1; i >= 0; i--) {
            env = Object.keys(envs)[i] as envsKeyType;
            $el.addClass(envs[env]);
            if ($el.is(":hidden")) {
                break; // env detected
            }
        }
        $el.remove();
        return env;
    }

    static isLocalEnvironment() {
        return window.location.hostname === "localhost" ||
            window.location.hostname === "[::1]" ||
            window.location.hostname === "127.0.0.1";
    }


    /**
    *  Removes query string from URL and reloads the page (to avoid duplicate Modal Dialog message, for example)
    */
    static removeQueryStringAndReloadWindow() {
        // Workaround for Firefox. Fixed in 70.0a1 https://bugzilla.mozilla.org/show_bug.cgi?id=1422334:
        // eslint-disable-next-line no-self-assign
        location.hash = location.hash;

        // Replace queryString and refresh
        window.history.replaceState({}, document.title, window.location.pathname);

        Functions.reloadLocation();
    }

    static reloadLocation() {
        //TODO: is this an issue? - is there some better solution?
        //https://stackoverflow.com/questions/55127650/location-reloadtrue-is-deprecated
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window.location as any).reload(true);
    }

    static addOrRemoveShiftFilterbuttonClass(searchMenuContentIdName: string, searchSelectionIdName: string) {
        if (document.getElementById("filterView") != null) {
            // Add shift-filterbutton class if the search menu is opened or if .search-list-selection has children
            if (document.getElementById(searchMenuContentIdName)?.getAttribute("aria-hidden") == "false" || $(searchSelectionIdName).children().length > 0) {
                document.getElementById("filterView")?.classList.add("shift-filterbutton");
            } else {
                document.getElementById("filterView")?.classList.remove("shift-filterbutton");
            }
        }
    }
    static hideHistory() {
        if ($("#historyView").is(":visible")) {
            Functions.changeSign();
        }
    }

    static changeSign() {
        const icon = $("#viewHistoryContainer").find("i");
        const view = $("#historyView");
        const link = $("#loadHistory");

        Functions.toggleAccessibility(icon, view, link, link.data("open"), link.data("close"));
    }

    static toggleAccessibility(icon: JQuery<HTMLElement>, view: JQuery<HTMLElement>, link: JQuery<HTMLElement>, opentext?: string, closetext?: string) {
        if (!view.hasClass("show") && !view.hasClass("collapsing")) {
            view.collapse("toggle");
            icon.removeClass("asf-ui-plus").addClass("asf-ui-close");
            link.attr("aria-label", closetext);
        } else if (view.hasClass("show") && !view.hasClass("collapsing")) {
            view.collapse("toggle");
            icon.addClass("asf-ui-plus").removeClass("asf-ui-close");
            link.attr("aria-label", opentext);
        }
    }

    static initLoadHistory() {
        $("#loadHistory, .sign").on("click",
            function (e) {
                Functions.changeSign();
                e.preventDefault();
                if ($("#historyView").text().trim() === $("#loadHistory").data("loading").trim()) {
                    $.ajax({
                        url: $("#loadHistory").data("url"),
                        type: "GET",
                        cache: false,
                        success: function (result) {
                            if (result.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                                $("#historyView").html(result.Data);
                            } else {
                                const errorText = (typeof $("#historyView").data("error") !== "undefined")
                                    ? $("#historyView").data("error")
                                    : result.Message;
                                $("#historyView").text(errorText);
                            }
                        },
                        error: function (error) {
                            const errorString = JSON.stringify(error);
                            App.Common.Logging.logWarning(`${$("#loadHistory").data("url")} - Error: "${errorString}"`);
                            $("#historyView").text($(this).data("error"));
                        }
                    });
                }
            });

    }

    static removeSelection(fieldId: string) {
        const field = <HTMLInputElement>document.getElementById(fieldId);
        field.value = "";
    }

    static buttonLoader(field: string | HTMLElement, isLoading: boolean) {
        const self = typeof field === "string" ? <HTMLElement>document.getElementById(field) : field;
        if (!self) return;
        const loadingText: string = self.getAttribute("data-loading-text") ??
            document.getElementById("body").getAttribute("data-loading-text");
        if (isLoading && self.getAttribute("disabled") === null) {
            self.setAttribute("disabled", "disabled");
            self.setAttribute("data-btn-text", self.innerHTML);
            self.innerHTML = "<span class=\"spinner-border\" role=\"status\"></span>&nbsp;" + loadingText;
            self.classList.add("has-spinner");
        } else if (!isLoading && self.getAttribute("disabled") === "disabled") {
            self.innerHTML = self.getAttribute("data-btn-text");
            self.classList.remove("has-spinner");
            self.removeAttribute("disabled");
        }
    }

    /**
   * Gets URL parameter by name. Url is optional.
   * @param {string} name Name of the parameter to read from URL
   * @param {string} url Url. Null to get from window.location.href.
   */
    static getUrlParameterByName(name: string, url?: string) {
        if (!url)
            url = window.location.href;
        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[\]]/g, "\\$&");

        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");

        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    static isIeOrEdge() {
        const userAgent = window.navigator.userAgent;
        return userAgent.indexOf("MSIE ") >= 0 || userAgent.indexOf("rv:11.0") >= 0 || userAgent.indexOf("Edge/") >= 0;
    }

    static replaceAll(string: string, from: string, to: string) {
        const escapedRegex = from.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        const regexp = new RegExp(escapedRegex, "ig");
        return string.replace(regexp, to);
    }

    static isMobileWorkflow() {
        return App.Common.Functions.getUrlParameterByName("origin") === "Mobile";
    }

    static germanDateStringTODateFormat(date: string | Date) {
        let dateString: string;
        if (date instanceof Date)
            dateString = date.toString();
        else
            dateString = date;

        const re = /^\d{2}\.\d{2}\.\d{4}$/;
        if (re.test(dateString)) {
            const adata = dateString.split(".");
            const dd = parseInt(adata[0], 10);
            const mm = parseInt(adata[1], 10);
            const yyyy = parseInt(adata[2], 10);
            return new Date(yyyy, mm - 1, dd);
        } else {
            return false;
        }
    }

    static formatDate(d: string | number | Date) {
        const date = new Date(d);
        const dd = date.getDate();
        const mm = date.getMonth() + 1;
        const yyyy = date.getFullYear();

        return (dd < 10 ? "0" : "")
            + dd + "."
            + (mm < 10 ? "0" : "")
            + mm + "." + yyyy;
    }

    static setCheckboxValue(checkbox: HTMLInputElement, value: boolean): void {
        if (checkbox.checked != value) {
            checkbox.checked = value;
            checkbox.dispatchEvent(new Event("change"));
        }
    }
}